import React, { useEffect, useState } from "react";
import backicon from "./../../../../../../Assets/icons/backIcon.svg";
// import "./index.scss";
import { useLocation, useNavigate } from "react-router-dom";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import axiosInstance from "../../../../../services/api/API";
import ROUTES_NAVIGATION from "../../../../../../routes/routes";
import { showCustomAlert } from "../../../../../customComponents/CustomSweetAlert";
import Loader from "../../../../../customComponents/CustomLoader";
import { showErrorAlert } from "../../../../../customComponents/CustomSweetAlert/errorsweetalert";
import { showAlert } from "../../../../../customComponents/CustomSweetAlert/ShowAlert";

const EditSubProduct = () => {
  const token = localStorage.getItem("authToken");
  const [formData, setFormData] = useState({
    product_name: "",
    subproduct_name: "",
    subproduct_desc: "",
    status: 1, // Default value for status
  });
  const [validationErrors, setValidationErrors] = useState({});
  const [productOptions, setProductOptions] = useState([]);
  const userType = localStorage.getItem("UserType");
  const authToken = localStorage.getItem("authToken");
  const [userTypedd, setUserTypedd] = useState([]);
  const location = useLocation();
  const { data } = location.state || {};
  const businessPartnerId = data?.business_partner_id
  const navigate = useNavigate();
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);



  useEffect(() => {
    
    fetchSubProduct();
  }, []);
  useEffect(()=>{
    console.log("formData",formData);
    
    fetchProductOptions();
  },[formData?.business_partner_id])

  const fetchSubProduct = async () => {
    try {
      const response = await axiosInstance.get(
        `/subproduct/edit/${data?.subproduct_id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const fetchedData = response?.data?.data;
      setFormData({
        business_partner_id: fetchedData?.business_partner_id,
        product_name: fetchedData?.product_id,
        subproduct_name: fetchedData?.subproduct_name,
        subproduct_desc: fetchedData?.subproduct_desc,
        status: fetchedData.status===1?true:false
      });
    } catch (error) {
      console.error(error);
    }
  };

  const fetchProductOptions = async () => {
    //alert("called")
    try {
      const response = await axiosInstance.post(
        "/product/ddlproduct",
        {
          business_partner_id:formData?.business_partner_id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const fetchedProducts = response.data.data.data;
      const options = fetchedProducts.map((product) => ({
        label: product.NAME,
        value: product.ID,
      }));
      setProductOptions(options);
    } catch (error) {
      console.error("Error fetching product options:", error);
    }
  };

  const handleFormSubmit = async () => {
    const errors = {};
    let isValid = true;
  
    // Validation logic
    SubProductInputsTemplate.forEach((field) => {
      if (field.validation) {
        if (field.name === "status" && formData.status === 0) {
          // Allow status = 0
        } else if (field.validation.required && !formData[field.name]) {
          errors[field.name] = "This field is required";
          isValid = false;
        } else if (
          field.validation.pattern &&
          !field.validation.pattern.test(formData[field.name])
        ) {
          errors[field.name] = field.validation.message;
          isValid = false;
        }
      }
    });
  
    // Set validation errors and exit if form is invalid
    if (!isValid) {
      setValidationErrors(errors);
      return;
    }
  
    // Prepare payload for API request
    const payload = {
      product_id: formData.product_name,
      subproduct_name: formData.subproduct_name,
      subproduct_desc: formData.subproduct_desc,
      status: formData.status===true?1:0,
    };
  
    try {
      const confirmation = await showAlert({
        title: "Confirmation",
        text: "Are you sure you want to update this record in Sub-Product?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "Cancel",
      });
  
      // If user cancels, exit early
      if (!confirmation.isConfirmed) {
        return;
      }
  
      setLoading(true); // Show loading state
      setIsFormSubmitted(true); // Indicate that form submission has started
  
      // Make API request to update the subproduct
      const response = await axiosInstance.patch(
        `/subproduct/update/${data.subproduct_id}`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
  
      // Show success alert after successful update
      if (response.status === 200) {
        await showAlert({
          title: "Success",
          text: "Sub-Product updated successfully.",
          icon: "success",
          confirmButtonText: "OK",
        });
  
        // Navigate after success
        navigate("/admin/manage-product/sub-product");
      }
    } catch (error) {
      console.error("Error updating subproduct:", error);
  
      // Show error alert on failure
      const errorMessage = error.response?.data?.message || "Failed to update sub-product. Please try again.";
      await showAlert({
        title: "Error",
        text: errorMessage,
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
      setLoading(false); // Hide loading state
    }
  };
  
  

  const SubProductInputsTemplate = [
    
    {
      name: "product_name",
      label: "Product Name",
      type: "dropdown",
      required: true,
      validation: { required: true },
      options: [],
      gridClass: "col-lg-4",
    },
    {
      name: "subproduct_name",
      label: "Name",
      type: "text",
      validation: {
        required: true,
        pattern: /^[A-Za-z0-9-\s]*$/,
        message: "Special symbols are not allowed",
      },
      required: true,
      gridClass: "col-lg-4",
    },
    {
      name: "subproduct_desc",
      label: "Description",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
    },
    {
      name: "status",
      label: "Status",
      type: "toggle",
      required: true,
      
      gridClass: "col-lg-4",
    },
  ];

  return (
    <>
     <div>
      {loading ? ( 
        <Loader />
      ) : (
      <><div className="backbutton mt-2 mb-2"  onClick={() => navigate(ROUTES_NAVIGATION.SUBPRODUCTLIST)} >
                          <img
                              src={backicon}
                              alt="back"
                              onClick={() => navigate(ROUTES_NAVIGATION.SUBPRODUCTLIST)} />
                          <span className="backbtntitle">Edit Sub Product</span>
                      </div><div className="form-container">
                              <span className="cust-det-title mt-2 mb-2">
                                  Please Edit Sub Product Details
                              </span>
                              <DynamicForm
                                  formConfig={SubProductInputsTemplate.map((field) => ({
                                      ...field,
                                      options: field.name === "product_name" ? productOptions : field.options,
                                  }))}
                                  formData={formData}
                                  setFormData={setFormData}
                                  onSubmit={handleFormSubmit}
                                  validationErrors={validationErrors}
                                  setValidationErrors={setValidationErrors} />
                          </div><div className="btncontainer mt-3">
                              <button onClick={handleFormSubmit} className="submit-btn">
                                  Submit
                              </button>
                          </div></>
       )}
       </div>
    </>
  );
};

export default EditSubProduct;
